import React from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ForgotPasswordForm from "../auth/ForgotPasswordForm";
import LoginForm from "../auth/LoginForm";
import RegisterForm from "../auth/RegisterForm";
import "../../customCSS/AuthModern.css";
import { closeAuthModal, setAuthMode } from "../../store/uiSlice";
import type { RootState } from "../../store/store";

/**
 * Global login/register/forgot-password popup. Mounted once in App.tsx.
 * Which form shows is driven by ui.authModal (store/uiSlice), opened from
 * the header, product buttons and the /login, /register, /forgetpassword
 * route redirectors.
 */
const AuthModal: React.FC = () => {
  const dispatch = useDispatch();
  const { open, mode } = useSelector((state: RootState) => state.ui.authModal);

  const handleHide = () => dispatch(closeAuthModal());

  return (
    <Modal show={open} onHide={handleHide} centered scrollable className="auth-modal">
      <Modal.Header closeButton />
      {/* data-lenis-prevent: the global Lenis smooth-scroll (App.tsx) treats
          any ancestor with this attribute as its own scroll container and
          lets the browser handle wheel/touch natively here, instead of
          scrolling the page behind the modal (see hooks/useLenis.ts). */}
      <Modal.Body data-lenis-prevent>
        <div className="auth-modal-body">
          {mode === "login" && (
            <LoginForm
              onSwitchToRegister={() => dispatch(setAuthMode("register"))}
              onSwitchToForgotPassword={() => dispatch(setAuthMode("forgotPassword"))}
            />
          )}
          {mode === "register" && (
            <RegisterForm onSwitchToLogin={() => dispatch(setAuthMode("login"))} />
          )}
          {mode === "forgotPassword" && (
            <ForgotPasswordForm onSwitchToLogin={() => dispatch(setAuthMode("login"))} />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AuthModal;
